<div class="se-external-docs-popup" style="height: 100%; width: 100%;flex-direction:column">
    <div class="se-dialog-header mat-elevation-z6" [class.se-dialog-header-error]="isOnError"
         [class.se-dialog-header-warning]="isDeletingDoc">
        <h3 *ngIf="isOnError" style="margin:0" mat-dialog-title translate>Error</h3>
        <h3 *ngIf="isDeletingDoc" style="margin:0" mat-dialog-title translate>Warning</h3>
        <h3 *ngIf="isConfirmedOp" style="margin:0" mat-dialog-title translate>Information</h3>
    </div>
    <div style="flex:1"></div>
    <p class="se-external-docs-dialog-error-message">{{messageBoxText}}</p>
    <div style="flex:1"></div>
    <button mat-button
            *ngIf="isOnError || isConfirmedOp"
            color="primary"
            style="font-size:1em; margin:10px;align-self: flex-end;"
            type="button"
            (click)="onConfirmOps('closeMessageBox')">
        <p style="margin:0" translate>Ok</p>
    </button>
    <div style="display:flex;flex-direction:row-reverse" *ngIf="isDeletingDoc">
        <button mat-button
                color="primary"
                style="font-size:1em; margin:10px;"
                type="button"
                (click)="onCancelOps('delete')">
            <p style="margin:0" translate>No</p>
        </button>
        <button mat-button
                color="primary"
                style="font-size:1em; margin:10px;"
                type="button"
                (click)="onConfirmOps('delete')">
            <p style="margin:0" translate>Yes</p>
        </button>
    </div>
</div>

